export default __webpack_public_path__ + "static/media/PPI-pools-024.5133764b.jpg";